const getters = {
  getAddProductCategory: (state) => state.addProductCategory,
  getEditProductCategory: (state) => state.editProductCategory,
  getProductCategoryList: (state) => state.productCategoryList,
  getIndustryList: (state) => state.industryList,
  getUploadProgress: (state) => state.uploadProgress,
  getIsNewInsurerCreated: (state) => state.isNewInsurerCreated,
  getInsurerDetail: (state) => state.insurerDetail,
};

export default getters;
